'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { objectCategoryProp } from 'FileManagerCore/constants/propTypes';
import RenameModal from '../modals/RenameModal';
import { getBulkSelectedFiles, getBulkSelectedFolders, getOpenModalName, getSelectedFolderOrFile, getSelectedObjectInfo } from '../../selectors/ModalDisplay';
import * as ModalTypes from '../../enums/ModalTypes';
import { closeModal } from '../../actions/Actions';
import DeleteFileModal from '../modals/DeleteFileModal';
import DeleteFolderModal from '../modals/DeleteFolderModal';
import ReplaceFileModal from '../modals/ReplaceFileModal';
import makeAsyncLoader from '../codeSplitting/makeAsyncLoader';
import PartitionFolderModal from '../modals/PartitionFolderModal';
import ReadonlyAcessPanel from '../modals/ReadOnlyAcessPanel';
import VideoFeaturesModal from '../modals/VideoFeaturesModal';
import AcademyVideoModal from '../modals/AcademyVideoModal';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncMoveModal = makeAsyncLoader(() => import( /* webpackChunkName: "move-modal" */'../modals/MoveModal').then(module => module.default));
const MODAL_COMPONENTS = {
  [ModalTypes.RENAME]: RenameModal,
  [ModalTypes.MOVE]: AsyncMoveModal,
  [ModalTypes.DELETE_FILE]: DeleteFileModal,
  [ModalTypes.DELETE_FOLDER]: DeleteFolderModal,
  [ModalTypes.REPLACE_FILE]: ReplaceFileModal,
  [ModalTypes.PARTITION_FOLDER]: PartitionFolderModal,
  [ModalTypes.VIEW_FOLDER_ACCESS]: ReadonlyAcessPanel,
  [ModalTypes.VIDEO_OPT_IN]: VideoFeaturesModal,
  [ModalTypes.ACADEMY_VIDEO]: AcademyVideoModal
};
class ModalsContainer extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.object && !this.props.object) {
      this.props.closeModal();
    }
  }
  render() {
    const {
      openModalName,
      object,
      bulkFiles,
      bulkFolders
    } = this.props;
    if (openModalName && (object || bulkFiles || bulkFolders) && MODAL_COMPONENTS[openModalName]) {
      const ModalComponent = MODAL_COMPONENTS[openModalName];
      if (openModalName === ModalTypes.DELETE_FOLDER) {
        return /*#__PURE__*/_jsx(ModalComponent, {
          folder: object
        });
      }
      if (openModalName === ModalTypes.DELETE_FILE) {
        return /*#__PURE__*/_jsx(ModalComponent, {
          file: object
        });
      }
      return /*#__PURE__*/_jsx(ModalComponent, Object.assign({}, this.props));
    }
    return null;
  }
}
ModalsContainer.propTypes = {
  openModalName: PropTypes.oneOf(Object.keys(MODAL_COMPONENTS)),
  object: PropTypes.instanceOf(Immutable.Map),
  objectCategory: objectCategoryProp,
  closeModal: PropTypes.func.isRequired,
  bulkFolders: PropTypes.instanceOf(Immutable.Set),
  bulkFiles: PropTypes.instanceOf(Immutable.Set)
};
const mapStateToProps = state => ({
  openModalName: getOpenModalName(state),
  objectCategory: getSelectedObjectInfo(state).objectCategory,
  object: getSelectedFolderOrFile(state),
  bulkFolders: getBulkSelectedFolders(state),
  bulkFiles: getBulkSelectedFiles(state)
});
const mapDispatchToProps = {
  closeModal
};
export default connect(mapStateToProps, mapDispatchToProps)(ModalsContainer);